import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import * as MuiAlert from '@mui/material/Alert'

export type AlertProps = MuiAlert.AlertProps

export function Alert({ children, ...props }: AlertProps) {
  return (
    <MuiAlert.default
      {...props}
      iconMapping={{
        success: <CheckCircleOutlineIcon fontSize='inherit' />,
      }}
    >
      {children}
    </MuiAlert.default>
  )
}
